import React from "react";
import { CiSearch } from "react-icons/ci";
import { FiGrid } from "react-icons/fi";
import { FaList, FaRegStar } from "react-icons/fa";
/* import { data } from "../data/files"; */
import { FaPlus } from "react-icons/fa6";
import { CiFolderOn, CiFilter, CiMenuKebab, CiEdit } from "react-icons/ci";
import CreateView from "../Component/CreateView";
import folder from "../Assets/folder.png";
import PdfIcon from "../Assets/PdfIcon.png";
import Excel from "../Assets/Excel.png";
import video from "../Assets/video.png";
import { BsDownload } from "react-icons/bs";
import { FaShareAlt } from "react-icons/fa";
import { CiSettings } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import DeleteView from "../Component/DeleteView";
import ShareView from "../Component/ShareView";
import EditView from "../Component/Editview";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa6";
import { MdCancel } from "react-icons/md";
import { IoGridOutline, IoHomeOutline } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import FileView from "../Component/FIleView";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import { FiShare2 } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { GoShareAndroid } from "react-icons/go";
import GenericIcon from "../Assets/GenericIcon.png";
import SettingView from "../Component/SettingView";
import { IoMdRefresh } from "react-icons/io";
import { CiStar } from "react-icons/ci";
import { getFileIcon } from "../utils/Icon";
import { deleteFolder, getAllFolder, getFolder } from "../api/folderapi";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { HiDotsVertical } from "react-icons/hi";
import { FileContext } from "../context/FileContext";
import { useContext } from "react";
import { FaCircleArrowDown } from "react-icons/fa6";
import { MdGridView } from "react-icons/md";
import { FaSortAmountDown } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { BsThreeDotsVertical } from "react-icons/bs";
import FileContainer from "./FileContainer";
import Loader from "./Loader";
import { toast } from "react-hot-toast";
import MenuComponent from "./MenuComponent";
import { formatBytes } from "../utils/sizeCalculater";
import MoveModal from "../Component/MoveModel";
import FileInformation from "../Component/FileInformation";

const OpenedFolder = () => {
  const {
    files,
    setFiles,
    viewType,
    setViewType,
    search,
    setSearch,
    setSortOption,
    sortOption,
  } = useContext(FileContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [folders, setFolders] = useState([]);
  /*  const [files, setFiles] = useState([]); */
  const [file, setFile] = useState(null);
  /*  const [isGridView, setIsGridView] = useState(true); */
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [add, setAdd] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const [fileType, setFileType] = useState("Folder");
  const [currentFolder, setCurrentFolder] = useState(null);
  const [newFileName, setNewFileName] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [passwordProduct, setPasswordProduct] = useState(
    folder.isLocked ? "Yes" : "No"
  );
  const [visible, setVisible] = useState(folder.password || "");
  const [settingOpen, setSettingOpen] = useState(false);
  const [selectedFolderForDelete, setSelectedFolderForDelete] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const dropdownRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  /*  const [viewType, setViewType] = useState("grid"); */
  const menuRef = useRef(null);
  const [selectedFolderId, setSelectedFolderId] = useState(null); // ✅ added
  const [isPasswordSet, setIsPasswordSet] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [infoModel, setInfoModel] = useState(false);
  const [renameValue, setRenameValue] = useState("");
  const [menuOpenId, setMenuOpenId] = useState(false);
  const [renamingId, setRenamingId] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkboxOpen, setCheckboxOpen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [selectedForMove, setSelectedForMove] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [infoFile, setInfoFile] = useState(null);
  const [showMoveModal, setShowMoveModal] = useState(false);

  const handleEdit = (index) => {
    setNewFileName(files[index].name);
    setIsEditing(index);
  };

  const handleRename = (index) => {
    const updatedFiles = [...files];
    updatedFiles[index].name = newFileName;
    updatedFiles[index].updatedAt = new Date().toLocaleString();
    setFiles(updatedFiles);
    setIsEditing(false);
  };

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const handleDownload = (icon, file) => {
    if (!icon) return;

    const element = document.createElement("a");
    element.href = icon;
    element.download = file;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const handleDeleteClick = (folder) => {
    setSelectedFolderForDelete(folder);
    setIsPopupOpen(true);
  };

  /*  const handleDeleteConfirm = () => {
    if (selectedFolderForDelete) {
      if (currentFolder && currentFolder.items) {
        const updatedItems = currentFolder.items.filter(
          (item) => item.id !== selectedFolderForDelete.id
        );
        setCurrentFolder({ ...currentFolder, items: updatedItems });
      } else {
        const updatedFiles = files.filter(
          (file) => file.id !== selectedFolderForDelete.id
        );
        setFiles(updatedFiles);
      }

      setIsPopupOpen(false);
      setSelectedFolderForDelete(null);
      setMenuOpen(null);
    }
  }; */

  const fetchFolders = async () => {
    try {
      setIsLoading(true);
      const res = await getAllFolder();
      const rootFolders = res.data.filter((d) => !d.parentId);
      setFiles(rootFolders);
    } catch (error) {
      console.error("Error fetching folders:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleSelection = (fileId) => {
    setSelectedItems((prev) =>
      prev.includes(fileId)
        ? prev.filter((id) => id !== fileId)
        : [...prev, fileId]
    );
  };

  const handleDeleteConfirm = async (_id, name) => {
    try {
      if (selectedFolderForDelete) {
        const res = await deleteFolder(selectedFolderForDelete._id); // Capture response

        toast.success(res.message);
        fetchFolders();
        setIsPopupOpen(false);
        setSelectedFolderForDelete(null);
        setMenuOpen(null);
      }
    } catch (error) {
      toast.error("Error deleting folder");
    }
  };

  const handleDeleteCancel = () => {
    setIsPopupOpen(false);
    setSelectedFolderForDelete(null);
  };

  const handleShare = () => {
    alert("Sharing...");
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    setVisible(e.target.value);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCancel = () => {
    setSettingOpen(false);
    setSelectedFolder(null);
  };

  const toggleMenu = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleFolderClick = (folder) => {
    if (folder.isLocked) {
      const enteredPassword = prompt(
        "This folder is locked. Enter the password:"
      );
      if (enteredPassword !== folder.password) {
        alert("Incorrect password! Access denied.");
        return;
      }
    }

    if (folder.isDirectory) {
      setBreadcrumb((prev) => [...prev, folder]);
      setCurrentFolder(folder);
    } else {
      console.log("File clicked (no drill‐down):", folder.name);
    }
  };

  const handleItemClick = (item) => {
    // setSelectedFolderId(item.id);

    // if (item.isLocked) {
    //   const enteredPassword = prompt(
    //     `This ${
    //       item.isDirectory ? "folder" : "file"
    //     } is locked. Enter the password:`
    //   );
    //   if (enteredPassword !== item.password) {
    //     alert("Incorrect password! Access denied.");
    //     return;
    //   }

    //   if (currentFolder) {
    //     setCurrentFolder((prev) => ({
    //       ...prev,
    //       items: prev.items.map((f) =>
    //         f.id === item.id ? { ...f, isLocked: false } : f
    //       ),
    //     }));
    //   } else {
    //     setFiles((prev) =>
    //       prev.map((f) => (f.id === item.id ? { ...f, isLocked: false } : f))
    //     );
    //   }
    // }

    if (item.type === "folder") {
      // openFolder(item);
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  const openFolder = (folder) => {
    setBreadcrumb((prev) => [...prev, folder]);
    setCurrentFolder(folder);
  };

  const openFolderSettings = (folder) => {
    setSelectedFolder(folder);
    setSettingOpen(true);

    setPasswordProduct(folder.isLocked ? "Yes" : "No");
    setVisible(folder.password || "");
    setIsPasswordSet((folder.password || "").trim() !== "");

    setSelectedFolderId(folder.id);
  };

  const handleSave = () => {
    if (!selectedFolder) {
      alert("No folder selected.");
      return;
    }
    if (passwordProduct === "Yes" && visible.trim() === "") {
      alert("Please enter a password");
      return;
    }

    const updatedFolder = {
      ...selectedFolder,
      isLocked: passwordProduct === "Yes",
      password: passwordProduct === "Yes" ? visible : "",
    };

    if (currentFolder) {
      setCurrentFolder((prev) => ({
        ...prev,
        items: prev.items.map((f) =>
          f.id === selectedFolder.id ? updatedFolder : f
        ),
      }));
    } else {
      setFiles((prevFiles) =>
        prevFiles.map((f) => (f.id === selectedFolder.id ? updatedFolder : f))
      );
    }

    setSettingOpen(false);

    setSelectedFolder(null);
  };

  const findFolderById = (arr, id) => {
    for (let item of arr) {
      if (item.id === id) return item;
      if (item.isDirectory && item.items.length > 0) {
        const found = findFolderById(item.items, id);
        if (found) return found;
      }
    }
    return null;
  };

  const handleBackClick = () => {
    if (breadcrumb.length > 1) {
      const newBreadcrumb = [...breadcrumb.slice(0, -1)];
      setBreadcrumb(newBreadcrumb);
      setCurrentFolder(newBreadcrumb[newBreadcrumb.length - 1]);
    } else {
      setBreadcrumb([]);
      setCurrentFolder(null);
    }
  };

  const displayedFiles = currentFolder ? currentFolder.items : files;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(null);
        setDropDown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getFolder(id)
      .then((res) => setFiles(res.data))
      .catch((err) => console.log(err));
    getAllFolder()
      .then((res) => {
        setFolders(res.data);
        setIsLoading(false);

        setFile(res.data.find((d) => d._id === id));
      })
      .catch((err) => console.log(err));
  }, [id, isCreateModalOpen]);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    setDropDown(false);
  };

  const handleToggle = () => {
    setViewType((prev) => (prev === "grid" ? "list" : "grid"));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className=" mt-[4%] ">
     

      <div className="  ">
         <div className=" flex items-center gap-3  font-medium text-black mt-10  ">
          <IoHomeOutline
            fontSize={18}
            className="text-black cursor-pointer"
            onClick={() => navigate("/")}
          />

          {file?.path?.split("/").map((b, i) => {
            if (i === 0) {
              return null;
            }
            return (
              <div
                key={i}
                className="flex items-center cursor-pointer"
                onClick={() =>
                  navigate(`/folder/${folders.find((d) => d._id === b)?._id}`)
                }
              >
                <IoIosArrowForward fontSize={16} className="text-secondary font-bold" />
                <span className=" hover:text-blue-600 transition-colors text-xs md:text-sm text-secondary">
                  {folders.find((d) => d._id === b)?.name}
                </span>
              </div>
            );
          })}

          <span className=' text-xs md:text-sm text-secondary font-bold' onClick={handleBackClick}>{file?.name}</span>
        </div> 

        <div className="w-full flex justify-end  ">
          <div className="flex border border-gray-300 rounded-md overflow-hidden w-fit h-10 shadow-sm">
            {/* List View Button */}
            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "list"
                  ? "bg-four text-black"
                  : "text-secondary hover:bg-gray-100"
              }`}
              onClick={() => {
                setViewType("list");
                setIsMenuOpen(false);
              }}
              aria-label="List View"
            >
              <FaList />
            </button>

            {/* Grid View Button */}
            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "grid"
                  ? "bg-four text-black"
                  : "text-secondary hover:bg-gray-100"
              }`}
              onClick={() => {
                setViewType("grid");
                setIsMenuOpen(false);
              }}
              aria-label="Grid View"
            >
              <IoGridOutline />
            </button>
          </div>
        </div>

      

        {viewType === "grid" ? (
          <div className=" flex flex-col  ">
            <div
             className='grid grid-cols-2 md:grid-cols-5 gap-5 '
            >
              {files
                .filter((file) => !file.trashed)
                .filter(
                  (file) =>
                    search?.toLowerCase() === "" ||
                    file.name?.toLowerCase().includes(search.toLowerCase())
                )
                .slice(0, showAll ? files.length : 5)
                .map((file) => {
                  const fileId = file._id || file.id;
                  const isSelected = selectedItems.includes(fileId);
                  const handleRenameConfirm = () => {
                    if (renameValue.trim()) {
                      setFiles((prev) =>
                        prev.map((f) =>
                          f._id === file._id
                            ? { ...f, name: renameValue.trim() }
                            : f
                        )
                      );
                    }
                    setRenamingId(null);
                  };

                  return (
                    <FileContainer
                      key={fileId}
                      className={` group cursor-pointer border p-2 rounded-md transition-all duration-300  ${
                        isSelected
                          ? "ring-2 ring-blue-500 bg-blue-50"
                          : "hover:ring-1 hover:ring-gray-400"
                      }`}
                    >
                      {checkboxOpen && (
                        <div className=" top-2 right-3 z-10">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => toggleSelection(fileId)}
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                          />
                        </div>
                      )}
                      <div className="w-10 h-12  ">
                        <img
                          className={`w-full h-full object-contain rounded-md ${
                            file.isLocked ? "blur-sm opacity-60" : ""
                          }`}
                          onClick={() => {
                            if (file.isLocked && file.privacy === "private") {
                              const entered = prompt("Enter password:");
                              if (entered === file.password)
                                handleItemClick(file);
                              else alert("Incorrect password");
                            } else {
                              handleItemClick(file);
                            }
                          }}
                          src={getFileIcon(file.name, file.url)}
                          alt={file.name}
                        />
                      </div>

                      {renamingId === file._id ? (
                        <input
                          autoFocus
                          value={renameValue}
                          onChange={(e) => setRenameValue(e.target.value)}
                          onBlur={() => setRenamingId(null)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleRenameConfirm();
                            else if (e.key === "Escape") setRenamingId(null);
                          }}
                          className="text-sm border outline-none  px-2 py-1 w-full rounded-md"
                        />
                      ) : (
                        <span
                          className=" font-medium text-sm truncate cursor-pointer"
                          onClick={() =>
                            !file.isLocked &&
                            (file.isDirectory
                              ? handleFolderClick(file)
                              : handleItemClick(file))
                          }
                        >
                          {file.name.slice(0, 20)}
                        </span>
                      )}

                      <div className="flex justify-between text-[11px] text-gray-600 w-full">
                        {(() => {
                          const filtered = datas.filter(
                            (f) => f.parentId === file._id
                          );
                          const totalSize = filtered.reduce(
                            (acc, cur) => acc + (cur.size || 0),
                            0
                          );
                          return (
                            <>
                              <span>{filtered.length} items</span>
                              <span>{formatBytes(totalSize)}</span>
                            </>
                          );
                        })()}
                      </div>
                      <div className="absolute top-2 right-2 flex space-x-2 text-black ">
                        <button>
                          <FaRegStar />
                        </button>
                        <button
                          onClick={() =>
                            setMenuOpenId(menuOpenId === fileId ? null : fileId)
                          }
                        >
                          <HiDotsVertical fontSize={20} />
                        </button>
                      </div>

                      {menuOpenId === fileId && (
                        <MenuComponent
                          file={file}
                          setMenuOpenId={setMenuOpenId}
                          renameValue={renameValue}
                          setRenameValue={setRenameValue}
                          setRenamingId={setRenamingId}
                          showShareModal={showShareModal}
                          infoModel={infoModel}
                          setInfoModel={setInfoModel}
                          setShowShareModal={setShowShareModal}
                          showInfoModal={showInfoModal}
                          setShowInfoModal={setShowInfoModal}
                          setInfoFile={setInfoFile}
                        />
                      )}
                      {showShareModal && (
                        <ShareView
                          setIsOpen={setShowShareModal}
                          handleShare={() => {
                            toast.success("File shared successfully!");
                            setShowShareModal(false);
                          }}
                        />
                      )}

                      {showInfoModal && infoFile && (
                        <FileInformation
                          showInfoModal={showInfoModal}
                          infoFile={infoFile}
                          onClose={() => setShowInfoModal(false)}
                        />
                      )}

                      {showMoveModal && selectedForMove && (
                        <MoveModal
                          file={selectedForMove}
                          folders={files.filter(
                            (f) => f.isDirectory && !f.trashed
                          )}
                          onClose={() => setShowMoveModal(false)}
                          onMove={(destinationId) => {
                            setFiles((prev) =>
                              prev.map((f) =>
                                f._id === selectedForMove._id
                                  ? { ...f, parentId: destinationId }
                                  : f
                              )
                            );
                            setShowMoveModal(false);
                            toast.success("Moved successfully");
                          }}
                        />
                      )}
                    </FileContainer>
                  );
                })}
            </div>
          </div>
        ) : (
          <div className="w-full overflow-x-auto mt-5">
            <table
              className=" min-w-[700px] w-full table-auto  text-sm text-left"
              ref={menuRef}
            >
             
              <thead className=" text-xs md:text-sm">
                <tr className="text-secondary font-semibold">
                  {["Name", "Created At", "More"].map((col, i) => (
                    <th
                      key={i}
                      className="p-2 md:p-4 whitespace-nowrap text-secondary"
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>

            
             <tbody>
  {displayedFiles
    .filter(
      (file) =>
        !search?.trim() ||
        file.name?.toLowerCase().includes(search.toLowerCase())
    )
    .map((file, index) => {
      const fileId = file.id || file._id;
      return (
        <tr key={fileId} className="hover:bg-third">
          {/* Name + Icon */}
          <td className="p-2 md:p-4 text-left">
            <div className="flex items-center gap-4">
              <div className="relative w-8 h-8 md:w-10 md:h-10">
                {file.isLocked && (
                  <FaLock
                    className="absolute top-0 left-0 text-red-500 z-10"
                    fontSize={14}
                  />
                )}
                <img
                  src={getFileIcon(file.name, file.url)}
                  alt={file.name}
                  onClick={() => handleItemClick(file)}
                  className={`w-full h-full rounded-md object-cover transition-all duration-300 ${
                    file.isLocked && !file.isDirectory
                      ? "blur-md opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                />
              </div>
              <span
                className="cursor-pointer font-medium text-secondary truncate max-w-[150px]"
                onClick={() =>
                  !file.isLocked &&
                  (file.isDirectory
                    ? handleFolderClick(file)
                    : setSelectedFile(file))
                }
              >
                {file.name.slice(0, 20)}
              </span>
            </div>
          </td>

          {/* Updated Date */}
          <td className="p-2 md:p-4 text-secondary whitespace-nowrap">
            {file.updatedAt?.slice(0, 10)}
          </td>

          {/* Menu */}
          <td className="p-2 md:p-4 relative">
            <div
              className="inline-flex items-center justify-center text-lg text-secondary cursor-pointer"
              onClick={() =>
                setMenuOpen(menuOpen === index ? null : index)
              }
            >
              <CiMenuKebab />
            </div>

            {/* MenuComponent */}
            {menuOpenId === fileId && (
              <MenuComponent
                file={file}
                setMenuOpenId={setMenuOpenId}
                renameValue={renameValue}
                setRenameValue={setRenameValue}
                setRenamingId={setRenamingId}
                showShareModal={showShareModal}
                infoModel={infoModel}
                setInfoModel={setInfoModel}
                setShowShareModal={setShowShareModal}
                showInfoModal={showInfoModal}
                setShowInfoModal={setShowInfoModal}
                setInfoFile={setInfoFile}
              />
            )}

            {/* Share Modal */}
            {showShareModal && (
              <ShareView
                setIsOpen={setShowShareModal}
                handleShare={() => {
                  toast.success("File shared successfully!");
                  setShowShareModal(false);
                }}
              />
            )}

            {/* File Info Modal */}
            <FileInformation
              showInfoModal={showInfoModal}
              infoFile={infoFile}
              onClose={() => setShowInfoModal(false)}
            />

            {/* Move Modal */}
            {showMoveModal && selectedForMove && (
              <MoveModal
                file={selectedForMove}
                folders={files.filter((f) => f.isDirectory && !f.trashed)}
                onClose={() => setShowMoveModal(false)}
                onMove={(destinationId) => {
                  setFiles((prev) =>
                    prev.map((f) =>
                      f._id === selectedForMove._id
                        ? { ...f, parentId: destinationId }
                        : f
                    )
                  );
                  setShowMoveModal(false);
                  toast.success("Moved successfully");
                }}
              />
            )}
          </td>
        </tr>
      );
    })}

  {/* Delete Confirmation Popup */}
  {isPopupOpen && (
    <tr>
      <td colSpan={3}>
        <DeleteView
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteConfirm={handleDeleteConfirm}
        />
      </td>
    </tr>
  )}

  {/* Settings Modal */}
  {settingOpen && (
    <tr>
      <td colSpan={3}>
        <SettingView
          settingOpen={settingOpen}
          setSettingOpen={setSettingOpen}
          selectedFolder={selectedFolder}
          setSelectedFolder={setSelectedFolder}
          currentFolder={currentFolder}
          setCurrentFolder={setCurrentFolder}
          files={files}
          setFiles={setFiles}
          openFolder={openFolder}
          setSelectedFile={setSelectedFile}
        />
      </td>
    </tr>
  )}
</tbody>

            </table>
          </div>
        )}

        {isCreateModalOpen && (
          <CreateView
            setIsCreateModalOpen={setIsCreateModalOpen}
            path={`${file?.path}${id}/`}
            parentId={id}
          />
        )}

        {selectedFile && (
          <FileView
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            handleDownload={handleDownload}
          />
        )}
      </div>
    </div>
  );
};

export default OpenedFolder;
